
import React, { useState } from "react";
import { Users, Goal, ArrowRightLeft } from "lucide-react";
import MatchLineup from "./MatchLineup";
import H2hDataShow from "./H2hDataShow";
// import WebSocketTest from "./WebSocketTest";


export default function MatchDetails({ data }) {

  return (
    <div className="mb-4 rounded-xl border shadow-lg bg-white dark:bg-gray-900 dark:border-gray-700 overflow-hidden">
{/* <WebSocketTest /> */}
      <div className="flex flex-col space-y-1.5 p-4 md:p-6 pb-3 bg-gradient-to-r from-green-500/10 via-transparent to-green-500/5">

        <h3 className="font-semibold tracking-tight flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-lg">

          {/* Left */}
          <div className="flex items-center gap-3">

            <div className="w-9 h-9 rounded-lg bg-green-500/20 flex items-center justify-center shrink-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5 text-green-500"
              >
                <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
              </svg>
            </div>

            <div>
              <span className="text-base font-semibold text-gray-900 dark:text-white">
                Match Details
              </span>

              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Lineups, goals & substitutions
              </p>
            </div>

          </div>

          {/* Right */}
          <div className="flex items-center gap-2 flex-wrap">

            {/* Match Status */}
            <div className="inline-flex items-center rounded-full border px-2.5 py-1 text-[10px] font-semibold bg-green-500/20 text-green-500 border-green-500/30">
              FT
            </div>

            {/* Score */}
            <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 px-3 py-1.5 rounded-lg">

              <img
                src={data?.team_home_badge}
                alt={data?.match_hometeam_name}
                className="w-5 h-5 object-contain"
              />

              <span className="text-lg font-bold text-gray-900 dark:text-white">
                {data?.match_hometeam_score}
              </span>

              <span className="text-sm text-gray-500">
                -
              </span>

              <span className="text-lg font-bold text-gray-900 dark:text-white">
                {data?.match_awayteam_score}
              </span>

              <img
                src={data?.team_away_badge}
                alt={data?.match_awayteam_name}
                className="w-5 h-5 object-contain"
              />

            </div>

          </div>

        </h3>
      </div>

      <div className="p-4">
        <MatchTabs data={data} />
      </div>
    </div>
  )
}

const MatchTabs = ({ data }) => {
  const [activeTab, setActiveTab] = useState("lineups");

  const tabs = [
    {
      id: "lineups",
      label: "Lineups",
      icon: <Users className="w-4 h-4" />,
    },
    {
      id: "goals",
      label: "Goals",
      icon: <Goal className="w-4 h-4" />,
    },
    {
      id: "subs",
      label: "Subs",
      icon: <ArrowRightLeft className="w-4 h-4" />,
    },
    {
      id: "h2h",
      label: "Head 2 Head",
      icon: <ArrowRightLeft className="w-4 h-4" />,
    },
  ];

  return (
    <div className="w-full mb-4">
      <div className="grid grid-cols-4 p-1 rounded-xl bg-gray-100 dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 shadow-sm">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`
              flex items-center justify-center gap-2
              px-3 py-2 rounded-lg text-xs sm:text-sm
              font-medium transition-all duration-300

              ${activeTab === tab.id
                ? "bg-blue-600 text-white shadow-md"
                : "text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white hover:bg-gray-200 dark:hover:bg-zinc-800"
              }
            `}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Example Content */}
      <div className="mt-4  bg-white dark:bg-zinc-900 dark:border-zinc-800">
        {activeTab === "lineups" && (
          <MatchLineup lineup={data?.lineup} />
        )}

        {activeTab === "goals" && (
          <MatchGoals 
          goalscorer={data?.goalscorer} 
          data={{
            team_away_badge: data?.team_away_badge,
            team_home_badge: data?.team_home_badge,
            match_awayteam_score: data?.match_awayteam_score,
            match_hometeam_score: data?.match_hometeam_score,
            match_awayteam_name: data?.match_awayteam_name,
            match_hometeam_name: data?.match_hometeam_name,
            match_awayteam_system: data?.match_awayteam_system,
            match_hometeam_system: data?.match_hometeam_system,
          }} />
        )}

        {activeTab === "subs" && (
          <MatchSubstitutions substitutions={{
            ...data?.substitutions,
            team_away_badge: data?.team_away_badge,
            team_home_badge: data?.team_home_badge,
            match_awayteam_score: data?.match_awayteam_score,
            match_hometeam_score: data?.match_hometeam_score,
            match_awayteam_name: data?.match_awayteam_name,
            match_hometeam_name: data?.match_hometeam_name,
            match_awayteam_system: data?.match_awayteam_system,
            match_hometeam_system: data?.match_hometeam_system,
          }} />
        )}
        {activeTab === "h2h" && (
          <H2hDataShow h2hData={{
            ...data?.h2hData,
            team_away_badge: data?.team_away_badge,
            team_home_badge: data?.team_home_badge,
            match_awayteam_score: data?.match_awayteam_score,
            match_hometeam_score: data?.match_hometeam_score,
            match_awayteam_name: data?.match_awayteam_name,
            match_hometeam_name: data?.match_hometeam_name,
            match_awayteam_system: data?.match_awayteam_system,
            match_hometeam_system: data?.match_hometeam_system,
          }} />
        )}
      </div>
    </div>
  );
}


function MatchSubstitutions({ substitutions }) {

  // Convert API data into UI format
  const teams = [
    {
      name: substitutions?.match_hometeam_name,
      logo: substitutions?.team_home_badge,
      count: substitutions?.home?.length || 0,
      subs: substitutions?.home?.map((item) => {
        const players = item.substitution.split(" | ");

        return {
          time: `${item.time}'`,
          out: players[0],
          in: players[1],
        };
      }),
    },

    {
      name: substitutions?.match_awayteam_name,
      logo: substitutions?.team_away_badge,
      count: substitutions?.away?.length || 0,
      subs: substitutions?.away?.map((item) => {
        const players = item.substitution.split(" | ");

        return {
          time: `${item.time}'`,
          out: players[0],
          in: players[1],
        };
      }),
    },
  ];

  return (
    <div className="mt-2">

      <div className="grid md:grid-cols-2 gap-4">

        {teams.map((team, index) => (

          <div
            key={index}
            className="bg-white dark:bg-zinc-900 border dark:border-zinc-800 rounded-xl p-4 shadow-sm"
          >

            {/* Team Header */}
            <div className="flex items-center gap-2 pb-3 border-b border-gray-200 dark:border-zinc-700">

              <img
                src={team.logo}
                alt={team.name}
                className="w-6 h-6 object-contain"
              />

              <span className="font-medium text-sm text-gray-900 dark:text-white">
                {team.name}
              </span>

              <span className="ml-auto px-2 py-1 rounded-full text-[10px] bg-gray-200 dark:bg-zinc-700 text-gray-700 dark:text-gray-200">
                {team.count}
              </span>

            </div>

            {/* Subs */}
            <div className="space-y-2 mt-3">

              {team.subs?.length > 0 ? (
                team.subs.map((sub, i) => (

                  <div
                    key={i}
                    className="flex items-center gap-2 rounded-lg px-3 py-2 bg-gray-100 dark:bg-zinc-800 text-xs"
                  >

                    {/* Time */}
                    <span className="shrink-0 px-2 py-1 rounded-full bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 text-[10px]">
                      {sub.time}
                    </span>

                    {/* Player OUT */}
                    <span className="text-red-500 truncate">
                      ↓ {sub.out}
                    </span>

                    <ArrowRightLeft className="w-3 h-3 text-gray-500 shrink-0" />

                    {/* Player IN */}
                    <span className="text-green-500 truncate">
                      ↑ {sub.in}
                    </span>

                  </div>
                ))
              ) : (
                <div className="text-center text-sm text-gray-500 py-6">
                  No substitutions found
                </div>
              )}

            </div>
          </div>

        ))}

      </div>
    </div>
  );
}


function MatchGoals({ goalscorer, data }) {

  // HOME TEAM GOALS
  const homeGoals =
    goalscorer?.filter((goal) => goal.home_scorer) || [];

  // AWAY TEAM GOALS
  const awayGoals =
    goalscorer?.filter((goal) => goal.away_scorer) || [];

  // Final UI Data
  const teams = [
    {
      name: data?.match_hometeam_name,
      logo: data?.team_home_badge,
      goalsCount: data?.match_hometeam_score || 0,

      goals: homeGoals.map((goal) => ({
        player: goal.home_scorer,
        minute: `${goal.time}'`,
        info: goal.info,
        score: goal.score,
      })),
    },

    {
      name: data?.match_awayteam_name,
      logo: data?.team_away_badge,
      goalsCount: data?.match_awayteam_score || 0,

      goals: awayGoals.map((goal) => ({
        player: goal.away_scorer,
        minute: `${goal.time}'`,
        info: goal.info,
        score: goal.score,
      })),
    },
  ];

  return (
    <div className="mt-2">

      <div className="grid md:grid-cols-2 gap-4">

        {teams.map((team, index) => (

          <div
            key={index}
            className="bg-white dark:bg-zinc-900 border dark:border-zinc-800 rounded-xl p-4 shadow-sm"
          >

            {/* Team Header */}
            <div className="flex items-center gap-2 pb-3 border-b border-gray-200 dark:border-zinc-700">

              <img
                src={team.logo}
                alt={team.name}
                className="w-6 h-6 object-contain"
              />

              <span className="font-medium text-sm text-gray-900 dark:text-white">
                {team.name}
              </span>

              <span className="ml-auto px-2 py-1 rounded-full text-[10px] bg-gray-200 dark:bg-zinc-700 text-gray-700 dark:text-gray-200">
                {team.goalsCount}
              </span>

            </div>

            {/* Goals List */}
            <div className="mt-3">

              {team.goals.length > 0 ? (

                <div className="space-y-2">

                  {team.goals.map((goal, i) => (

                    <div
                      key={i}
                      className="rounded-lg px-3 py-2 bg-gray-100 dark:bg-zinc-800"
                    >

                      <div className="flex items-center gap-3">

                        <Goal className="w-4 h-4 text-green-500 shrink-0" />

                        <span className="text-sm font-medium text-gray-900 dark:text-white">
                          {goal.player}
                        </span>

                        <span className="ml-auto text-sm font-semibold text-blue-600 dark:text-blue-400">
                          {goal.minute}
                        </span>

                      </div>

                      {/* Extra Info */}
                      <div className="flex items-center justify-between mt-1">

                        <span className="text-[11px] text-gray-500 dark:text-gray-400">
                          {goal.info || "Goal"}
                        </span>

                        <span className="text-[11px] font-medium text-gray-500 dark:text-gray-400">
                          {goal.score}
                        </span>

                      </div>

                    </div>

                  ))}

                </div>

              ) : (

                <p className="text-xs text-gray-500 dark:text-gray-400 py-3">
                  No goals
                </p>

              )}

            </div>

          </div>

        ))}

      </div>
    </div>
  );
}
